import React, { useState } from 'react';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { FieldCheckbox, ValidationError, OutsideClickHandler } from '../../components';

import css from './FieldMultiSelect.module.css';

const FieldMultiSelectRenderer = props => {
    const {
        id,
        label,
        placeholder,
        options,
        fields,
        meta,
        className,
        rootClassName,
    } = props;

    const [isOpen, setIsOpen] = useState(false);

    const selectedValues = fields.value || [];
    const toggleDropdown = () => setIsOpen(!isOpen);
    const closeDropdown = () => setIsOpen(false);

    const buttonLabel = selectedValues.length === 0
        ? placeholder || 'Select sessions...'
        : selectedValues.length === 1
            ? options.find(o => o.key === selectedValues[0])?.label || '1 session selected'
            : `${selectedValues.length} sessions selected`;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            {label && <label className={css.label} htmlFor={id}>{label}</label>}
            <OutsideClickHandler onOutsideClick={closeDropdown}>
                <button
                    id={id}
                    type="button"
                    className={css.toggleButton}
                    onClick={toggleDropdown}
                    aria-haspopup="listbox"
                    aria-expanded={isOpen}
                >
                    <span className={classNames({ [css.placeholder]: selectedValues.length === 0 })}>
                        {buttonLabel}
                    </span>
                    <svg
                        className={classNames(css.arrow, { [css.arrowOpen]: isOpen })}
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>

                {isOpen && (
                    <div className={css.dropdown}>
                        <ul className={css.list} role="listbox">
                            {options.map((option, index) => {
                                const fieldId = `${id}.${option.key}`;
                                return (
                                    <li key={fieldId} className={css.item} role="option">
                                        <div className={css.checkboxWrapper}>
                                            <FieldCheckbox
                                                id={fieldId}
                                                name={fields.name}
                                                label={option.label}
                                                value={option.key}
                                                labelClassName={css.checkboxLabel}
                                            />
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </OutsideClickHandler>
            <ValidationError fieldMeta={meta} />
        </div>
    );
};

const FieldMultiSelect = props => {
    return <FieldArray component={FieldMultiSelectRenderer} {...props} />;
};

export default FieldMultiSelect;
